export enum EnumModals{
    INVOICE_DOWNLOAD_MODAL="INVOICE_DOWNLOAD_MODAL",
    COMMON_MODAL="COMMON_MODAL",
}